export const PULSE_CADENCES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  YEARLY: 'yearly',
} as const;
export type PulseCadence = typeof PULSE_CADENCES[keyof typeof PULSE_CADENCES];

export type PulseCadencePeriod = 'current' | 'previous';

type PulseCadenceLabels = {
  label: string;
  current: string;
  previous: string;
  future: string;
};
export const PULSE_CADENCE_LABELS: Record<PulseCadence, PulseCadenceLabels> = {
  [PULSE_CADENCES.DAILY]: {
    label: 'Daily',
    current: 'Today',
    previous: 'Yesterday',
    future: 'Tomorrow'
  },
  [PULSE_CADENCES.WEEKLY]: {
    label: 'Weekly',
    current: 'This Week',
    previous: 'Last Week',
    future: 'Next Week'
  },
  [PULSE_CADENCES.MONTHLY]: {
    label: 'Monthly',
    current: 'This Month',
    previous: 'Last Month',
    future: 'Next Month'
  },
  [PULSE_CADENCES.QUARTERLY]: {
    label: 'Quarterly',
    current: 'This Quarter',
    previous: 'Last Quarter',
    future: 'Next Quarter'
  },
  [PULSE_CADENCES.YEARLY]: {
    label: 'Yearly',
    current: 'This Year',
    previous: 'Last Year',
    future: 'Next Year'
  },
} as const;

export const PULSE_UNIT_TYPES = {
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
  CURRENCY: 'currency',
  COUNT: 'count',
  FLOAT: 'float',
  PERCENTAGE: 'percentage',
} as const;
export type PulseUnitType = typeof PULSE_UNIT_TYPES[keyof typeof PULSE_UNIT_TYPES];

export interface PulseHistoricalParams {
  excludeZeroScores: boolean;
  fromDate?: string;
  toDate?: string;
  scoringGroupId?: number;
}
